/**
 * US School Holidays - computed by formula, not stored in DB.
 */

function nthDayOfMonth(year, month, dayOfWeek, n) {
  const first = new Date(year, month, 1);
  let offset = (dayOfWeek - first.getDay() + 7) % 7;
  return new Date(year, month, 1 + offset + (n - 1) * 7);
}

function lastDayOfMonth(year, month, dayOfWeek) {
  const last = new Date(year, month + 1, 0);
  let offset = (last.getDay() - dayOfWeek + 7) % 7;
  return new Date(year, month, last.getDate() - offset);
}

function toKey(date) {
  return date.toISOString().split('T')[0];
}

function dateRange(start, end) {
  const dates = [];
  const current = new Date(start);
  while (current <= end) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }
  return dates;
}

export function getUSSchoolHolidays(year) {
  const holidays = [];

  // Labor Day - 1st Monday of September
  holidays.push({
    date: nthDayOfMonth(year, 8, 1, 1),
    name: 'Labor Day',
    emoji: '\u{1F3D6}\u{FE0F}',
  });

  // Columbus Day - 2nd Monday of October
  holidays.push({
    date: nthDayOfMonth(year, 9, 1, 2),
    name: 'Columbus Day',
    emoji: '\u{1F30E}',
  });

  // Veterans Day - November 11
  holidays.push({
    date: new Date(year, 10, 11),
    name: 'Veterans Day',
    emoji: '\u{1F1FA}\u{1F1F8}',
  });

  // Thanksgiving break - Wed through Fri of 4th Thursday week
  const thanksgiving = nthDayOfMonth(year, 10, 4, 4);
  const thanksgivingWed = new Date(thanksgiving);
  thanksgivingWed.setDate(thanksgivingWed.getDate() - 1);
  const thanksgivingFri = new Date(thanksgiving);
  thanksgivingFri.setDate(thanksgivingFri.getDate() + 1);
  for (const d of dateRange(thanksgivingWed, thanksgivingFri)) {
    holidays.push({
      date: d,
      name: 'Thanksgiving Break',
      emoji: '\u{1F983}',
    });
  }

  // Winter break - Dec 23 through Jan 1
  for (const d of dateRange(new Date(year, 11, 23), new Date(year, 11, 31))) {
    holidays.push({
      date: d,
      name: 'Winter Break',
      emoji: '\u{2744}\u{FE0F}',
    });
  }
  holidays.push({
    date: new Date(year + 1, 0, 1),
    name: 'Winter Break',
    emoji: '\u{2744}\u{FE0F}',
  });

  // Also add Jan 1 of current year (from previous year's winter break)
  holidays.push({
    date: new Date(year, 0, 1),
    name: "New Year's Day",
    emoji: '\u{1F389}',
  });

  // MLK Day - 3rd Monday of January
  holidays.push({
    date: nthDayOfMonth(year, 0, 1, 3),
    name: 'MLK Day',
    emoji: '\u{270A}',
  });

  // Presidents' Day - 3rd Monday of February
  holidays.push({
    date: nthDayOfMonth(year, 1, 1, 3),
    name: "Presidents' Day",
    emoji: '\u{1F3DB}\u{FE0F}',
  });

  // Spring break - 3rd full week of March (Mon-Fri)
  const springMon = nthDayOfMonth(year, 2, 1, 3);
  const springFri = new Date(springMon);
  springFri.setDate(springFri.getDate() + 4);
  for (const d of dateRange(springMon, springFri)) {
    holidays.push({
      date: d,
      name: 'Spring Break',
      emoji: '\u{1F33B}',
    });
  }

  // Memorial Day - last Monday of May
  holidays.push({
    date: lastDayOfMonth(year, 4, 1),
    name: 'Memorial Day',
    emoji: '\u{1F1FA}\u{1F1F8}',
  });

  return holidays;
}

/**
 * Build a lookup map merging built-in US holidays + custom user school days.
 * Returns: { 'YYYY-MM-DD': { name, emoji, type, id? } }
 */
export function buildHolidayMap(startDate, endDate, customSchoolDays = []) {
  const map = {};

  // Compute which years we need
  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();

  for (let y = startYear; y <= endYear; y++) {
    for (const h of getUSSchoolHolidays(y)) {
      const key = toKey(h.date);
      // Only include if within range
      if (h.date >= startDate && h.date <= endDate) {
        map[key] = { name: h.name, emoji: h.emoji, type: 'builtin' };
      }
    }
  }

  // Merge custom days (override built-in if same date)
  for (const day of customSchoolDays) {
    const key = typeof day.date === 'string' ? day.date.split('T')[0] : toKey(new Date(day.date));
    map[key] = { name: day.name, emoji: '\u{1F4CC}', type: 'custom', id: day.id };
  }

  return map;
}
